<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('configurations.link_company')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('configurations.link_company')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 40vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRefAgencies">
              <AccessibleElSelect
                prop="company"
                v-model="form.companies"
                :isMultiple="true"
                :isDisabled="isLoadingSelect"
                :options="companies.map(company => ({ id: company.value, name: company.label }))"
                id-prefix="certLinkDialog"
              >
                <template #label>
                  {{ $t('configurations.company') }}
                </template>
              </AccessibleElSelect>
              
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button 
          class="w-full"
          mode="secondary-phantom-blue"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="handleSelectAll" 
          :loading="isLoadingSelect"
          />
        <base-button 
          class="w-full "
          v-else :text="$t('app.unselect_all')" 
          mode="secondary-phantom-blue"
          @click="handleUnSelectAll"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
          <div class="w-48 "></div>
          <base-button 
            class="w-full"
            @click="toggleDialog" 
            mode="secondary-phantom-blue" 
            :text="$t('app.cancel')" 
            :loading="isLoadingSelect"
            :disabled="isLoadingSelect"/>
          <base-button 
            mode="secondary-phantom-blue" 
            class="w-full " 
            :text="$t('app.accept')" 
            @click="apply" 
            :loading="isLoadingSelect"
            :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
// import { companies } from '@/services/app/getCompanies'
import { getAllCompanies } from '@/services/companies/getAllCompanies'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'certificate-link-company-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    certificate: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        companies: []
      },
      companies: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    const data = await getAllCompanies({ idEmpresaCert: this.$route.params.idEmpresa })
    if (data.blnError === true) {
      this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
    } else {
      data.CIFSEmpresa.forEach(row => {
        this.companies.push({ value: row.IdCIFEmpresa, label: row.CIF + ' - ' + row.NombreCIF })
      })
    }
    this.isLoadedData = true
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isEmptyList: function () {
      return this.companies === undefined || this.companies === null || this.companies.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.companies.length === this.form.companies.length) return true
      else return false
    }
  },
  methods: {
    onExpand (value) {
      // console.log('expand OPEN')
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      // console.log('onChangeInput', 'onChangeInput')
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.companies = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', [this.form.companies])
      this.form.companies = []
    },
    handleSelectAll: async function () {
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.companies.forEach(element => {
        setTimeout(() => {
          this.form.companies.push(element.value)
          if (this.form.companies.length === this.companies.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.companies.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.companies.pop()
          if (this.form.companies.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
